/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.19.0
 */

import { API_SUBSCRIBERS_LIST_STATUS } from '@modules/app/Api';

import { pageApi } from '../../api/page.api';

export const subscriberApi = pageApi.injectEndpoints({
    endpoints: (builder) => ({
        getTableStatus: builder.query<{ isComplete: boolean }, void>({
            query: () => API_SUBSCRIBERS_LIST_STATUS,
        }),
    }),
});

export const {
    useLazyGetTableStatusQuery,
} = subscriberApi
